
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqPX_LrPkG8f1B9slmv1uQcfM9N21CO4PEpC1yKq_45oJ1MMeta } from "/codebuild/output/src1956426805/src/src/pages/faq.vue?macro=true";
import { default as menu9XTjEeyZDwTcZQublbiBZ4L0NOqAZxDkB0RZ5nG6MUQMeta } from "/codebuild/output/src1956426805/src/src/pages/menu.vue?macro=true";
import { default as indexgF0Lz1lfOXDb8Jofb7_45OxlA1stXUPe0C1diiuWS8eJcMeta } from "/codebuild/output/src1956426805/src/src/pages/index.vue?macro=true";
import { default as contactm9IUp0T7g3l5CR4mn7m8nWwRVFMTSpIr6IKCUav5JycMeta } from "/codebuild/output/src1956426805/src/src/pages/contact.vue?macro=true";
import { default as tutorial2ccx2XGyGlpU6_JjvJUQzY9dHKmEbY1M3rj1oM8IdesMeta } from "/codebuild/output/src1956426805/src/src/pages/tutorial.vue?macro=true";
import { default as agreementTPEH4Z2Hrda_Uixm25on7kU2exrsbQPBoyRxGnuhh44Meta } from "/codebuild/output/src1956426805/src/src/pages/agreement.vue?macro=true";
import { default as about_45passysnbziP72lcN76qFJLxtIsB8Y7CSpxncvnf7cYb6fMkMeta } from "/codebuild/output/src1956426805/src/src/pages/about-pass.vue?macro=true";
import { default as indexc5PmiZW6OXG2arZaDIKPk6Be2h3FM7gQc44AXP_nIbAMeta } from "/codebuild/output/src1956426805/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93SWfcfIInPmpKNohl3Lv_P_yghyWS3_45icgZ8wqY3qH_45oMeta } from "/codebuild/output/src1956426805/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenanceC_7BBWzNOkZO6zHpn9DJHU5oPPwOKHUdq8JJ0vA_45n_45sMeta } from "/codebuild/output/src1956426805/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_938QcJFDG32iHoNDe01WUXeBBC_zgLzqbG1n0SQW8HrLEMeta } from "/codebuild/output/src1956426805/src/src/pages/notice/[id].vue?macro=true";
import { default as index7QpLQsJDch3iRWsXR6KfBp8QtrIX3TPT1eM3natQdyYMeta } from "/codebuild/output/src1956426805/src/src/pages/coupon/index.vue?macro=true";
import { default as index2WqHqlXfJ0Z55Db366q7htLHnqW4LcoYsH7JAAK9vlMMeta } from "/codebuild/output/src1956426805/src/src/pages/mypage/index.vue?macro=true";
import { default as index0asjcLmxUw_HUOQqfIm2GYAXA2SCRw11U08xLekTsFQMeta } from "/codebuild/output/src1956426805/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93j6Sc9fdae1sZoczeP3K0V_dIlvOsFTmTqHNiboxhy8AMeta } from "/codebuild/output/src1956426805/src/src/pages/parking/[id].vue?macro=true";
import { default as indexuIrDXTA8MI9R_45moDIi375sCgVXV4GxFixm9MaY5WdDAMeta } from "/codebuild/output/src1956426805/src/src/pages/history/index.vue?macro=true";
import { default as indexMma9oQVG_450_45_eZzDtaHcbHd29qSeFB512F7KS4OLBtIMeta } from "/codebuild/output/src1956426805/src/src/pages/monthly/index.vue?macro=true";
import { default as index5cXC47_3CmdKbR33UgOawNwxDFkybqIynL_YJWasQOkMeta } from "/codebuild/output/src1956426805/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexwlR2xgGpA8VgwaRn4vWIDweqO51v_vhcpjqrT0Cpf0oMeta } from "/codebuild/output/src1956426805/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviqFdxyyjv9c6gJzsdmDqHlvsV1NbrPvJfoLOlxmTqwRQMeta } from "/codebuild/output/src1956426805/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editQso2Erfbmx0K55T3KpoIHQqk8AVhEPwOwOtOntJLeksMeta } from "/codebuild/output/src1956426805/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementnJKMNMvIv4TvSk2a66lnSUecfogYn6cDgHVg2dgutFEMeta } from "/codebuild/output/src1956426805/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexFbiC_45IiJkJLRbrV3VTe6l8ZpR365DoqqAmn0rqh8jhEMeta } from "/codebuild/output/src1956426805/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dnWsc5CcXfJhDRgtC6_2kI4JB_3XkCPkoHgRzEOfhWQUMeta } from "/codebuild/output/src1956426805/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirm20y_EH9GMVTk_45DXxxgZa9tAPsApWc49wpq66DluBVgUMeta } from "/codebuild/output/src1956426805/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexbGYJNEwl9Vl9XqE3aMOznzcWeUbVZiLjw0lT9C9oIlwMeta } from "/codebuild/output/src1956426805/src/src/pages/card/create/index.vue?macro=true";
import { default as indexm0iLy7XRQ3ekUqWhCpYqvHndysou_45p_PQkBxPMNM0CgMeta } from "/codebuild/output/src1956426805/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmq9gM25FSyrNn7kF7IwbT2SNJgmd0swmXRFLiUwbjbQcMeta } from "/codebuild/output/src1956426805/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmuYpRStyUMuis4_5kCJDHEYRDVSdPkTvHdA81tJIPRWEMeta } from "/codebuild/output/src1956426805/src/src/pages/card/create/confirm.vue?macro=true";
import { default as complete1nOjJhHAO_45GABEa_45B_45oPt3hv42qF4wp1Kdomof5hK9QMeta } from "/codebuild/output/src1956426805/src/src/pages/membership/complete.vue?macro=true";
import { default as registerTRqugVQOjNp3vVUGoQoTtkL0Ymx1GU8_45X1h5cNWT9V8Meta } from "/codebuild/output/src1956426805/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93J5hgHbcV3jeNIDKb66h9id3ZIjPnBsuSRNg0yEKml1MMeta } from "/codebuild/output/src1956426805/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmQloY017mwHtbxIi0rulvigEInUi818Maf5KBhqP0B6IMeta } from "/codebuild/output/src1956426805/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93NcDOi_wJpMLZqmMG9exdUyce1yQS3ttkYV5K7ZDiuG4Meta } from "/codebuild/output/src1956426805/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexw2ViP7biYnJdBVh5LUqLT1brRiHIfeXFXw09aE58rCcMeta } from "/codebuild/output/src1956426805/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeIUWVRuIiiUB3KQuvvjalRhooIxmHSLNbFHhh_3eMDPkMeta } from "/codebuild/output/src1956426805/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codebPw8nAgZE6gVcJDiyXj5EgrqMPZlQtj3a03bR2maUhUMeta } from "/codebuild/output/src1956426805/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as complete27hfb7tgKkwbVl4a0u5mk9aM3eZVBQ_459KTLAPugk5D8Meta } from "/codebuild/output/src1956426805/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerjzW6qIiufp2WyCIDCeuvOa4tyBj9h4IrWFNhjGOGQbAMeta } from "/codebuild/output/src1956426805/src/src/pages/contact-form/register.vue?macro=true";
import { default as completejTkLk0YDaIRQbiUQgVxcfQgyzNmfZPr_45J7iZiawp8s4Meta } from "/codebuild/output/src1956426805/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexJ632sCEGd8rfEtNbrmSzeftcgWRhUbovXMkAIGHN7NgMeta } from "/codebuild/output/src1956426805/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmhrQEvdd_xDi25x3D6WtMGby_455VhF2KQdPo9WttXYD3IMeta } from "/codebuild/output/src1956426805/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completeUezLFjgvKWo2cf9UxgbaVmKcxN_45CCXwfL8uMdvcnRi4Meta } from "/codebuild/output/src1956426805/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexHfJpFQIFb8lTF_BgzR_45mmd8PbQAaPdXJiCb20iqCRhEMeta } from "/codebuild/output/src1956426805/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_937a117g070i8ZJQ0_452jqWOoHxUjHUcdYoYkSwr5L0mccMeta } from "/codebuild/output/src1956426805/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completedii3t1C12rAXvfBL9ITjUTFI9WKUga_45AbHWhS4UWiv0Meta } from "/codebuild/output/src1956426805/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasPjM3jYl8TJXOCZaNhqSNpS0yo26vYCN1bZH5IZQ0Ke0Meta } from "/codebuild/output/src1956426805/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampleVfsZzA4f8QpU5LXJDPka33MHv5odFn56npUNWkuIhMgMeta } from "/codebuild/output/src1956426805/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45email8abyHtIjnAvuglf1iJv6sujs_FMuI3m29fB3NPHjLeEMeta } from "/codebuild/output/src1956426805/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmHyplM4oeZC13uTaOwjyKf9vy2vpC_vGmQp0IPV44f2kMeta } from "/codebuild/output/src1956426805/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consenthlk3OsUJ7_lylObiGtBCLBKEnV3824Vs8Jz7cmoGdYUMeta } from "/codebuild/output/src1956426805/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmhegujwnzKSC44S1hPbRmqv7zkV90T_qVxzShe12a_45SkMeta } from "/codebuild/output/src1956426805/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedatexFIaCQB9SO9FIOxgYPscMfywccsq3VS2AlTGwgnMrVEMeta } from "/codebuild/output/src1956426805/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeqvRiZKFUuB8asoaICQGVcAEPf8AWP4lG3Faggva6QfwMeta } from "/codebuild/output/src1956426805/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codekTtAR_pP6FYJuezqT8fXJzGLGXSyrNKyEImVYkM5of0Meta } from "/codebuild/output/src1956426805/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45password6H8ZfK8hclhaUm_45FSvssq0wUitTfQjo6F3TLQtd3iLsMeta } from "/codebuild/output/src1956426805/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasNssYhnn7crPN1e2RFt9retbdW4aARBVsvSZo6jQ0d9YMeta } from "/codebuild/output/src1956426805/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerK2BLUf_45wyT3r47pegfX74TgrrkSV4fwiQS2RBCMPQkwMeta } from "/codebuild/output/src1956426805/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeE5WUgxd5A7NoBMis0N4btUGDOuRlh7_gweYPrLLJQiMMeta } from "/codebuild/output/src1956426805/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexHYCXyKvku9PbSQkHMtYdtnE676O_YGzzmfNTBumuzdsMeta } from "/codebuild/output/src1956426805/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexdOX2bXyXAM1lMOZ3UHVhDFdNNOubfcQqzy1gHnVt5GcMeta } from "/codebuild/output/src1956426805/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexbAhlbVqkCHlmHUtvWn4HJ73NN_HL_45jhcKAuHqeMJU0gMeta } from "/codebuild/output/src1956426805/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexKjlrxCAvLabpOofHDwj8HkVzW2FcgOqYoKsg2rGqWMgMeta } from "/codebuild/output/src1956426805/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateRCDtIxe07WPbbGz4U2e31loXyv3WzSBSlMHvEO5UqoYMeta } from "/codebuild/output/src1956426805/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completeKRTbperxlFQHQ7PucdeEca5qKmhUP6Tw1fTCmREHaiEMeta } from "/codebuild/output/src1956426805/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmBZjPPlk95efteAY8Q9aOfi0CumpIMKKnsxvq__45_450xuAMeta } from "/codebuild/output/src1956426805/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexVstI9QY_45_452I770WQk9EiDTOTkhqkVM514hLG43UVQNIMeta } from "/codebuild/output/src1956426805/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completecnpEoJBv9OefCD_vDxC6Dk4JWav3JKeD2JWEipecMHkMeta } from "/codebuild/output/src1956426805/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updatekewFAGgtpIG2RgbPsIsYE3s4URweEmMVJhTjTM8vMkYMeta } from "/codebuild/output/src1956426805/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as index3osM7QA9ItBk5gONzwqsZUF_45FRY7NrFOEhU4xiI3Ez8Meta } from "/codebuild/output/src1956426805/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexNCbbJn_TuRNeKxC6nJDw4off7I7sePZ9horFIy0lxuEMeta } from "/codebuild/output/src1956426805/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeVgYE3m_45lbkXToU1V7ntMhajC3rIuQHk8k2e4rVpybkoMeta } from "/codebuild/output/src1956426805/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexpXlw7L0ksZaVYDatuOUukok_8m7tkj03al8TlnGvvbYMeta } from "/codebuild/output/src1956426805/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeIqupFAz5A4OzkKM95fW8YUbuUsAC7MzYSSQruIzEEO0Meta } from "/codebuild/output/src1956426805/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as index2_zpzRLXqtLrDh7k5SFf0jfRPr9yPS2lnAjE_IH8w3MMeta } from "/codebuild/output/src1956426805/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexJr8cn0UH9Z_ozAdnfoH7M6LG5Y7fsZrajEZw4ZGcZYQMeta } from "/codebuild/output/src1956426805/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexOW7n_4545sDWg_83mAF8cXRLAqDCfI_45DRNgqUNKSmNv1MMeta } from "/codebuild/output/src1956426805/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updatebTP0Uy8KHMxdE2C6Efu6fO6WX0x2mJpDZza3ZhdJ7hoMeta } from "/codebuild/output/src1956426805/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmKOlLV6plE_45Ls0g6nStZ3AAvX_eSosCyg2BJIANc_XqcMeta } from "/codebuild/output/src1956426805/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src1956426805/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menu9XTjEeyZDwTcZQublbiBZ4L0NOqAZxDkB0RZ5nG6MUQMeta || {},
    component: () => import("/codebuild/output/src1956426805/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(indexgF0Lz1lfOXDb8Jofb7_45OxlA1stXUPe0C1diiuWS8eJcMeta || {}), ...{"middleware":["search-params"]} },
    component: () => import("/codebuild/output/src1956426805/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src1956426805/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src1956426805/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src1956426805/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src1956426805/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src1956426805/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src1956426805/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src1956426805/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src1956426805/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(index7QpLQsJDch3iRWsXR6KfBp8QtrIX3TPT1eM3natQdyYMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src1956426805/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src1956426805/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src1956426805/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src1956426805/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexuIrDXTA8MI9R_45moDIi375sCgVXV4GxFixm9MaY5WdDAMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src1956426805/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src1956426805/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: index5cXC47_3CmdKbR33UgOawNwxDFkybqIynL_YJWasQOkMeta || {},
    component: () => import("/codebuild/output/src1956426805/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexwlR2xgGpA8VgwaRn4vWIDweqO51v_vhcpjqrT0Cpf0oMeta || {},
    component: () => import("/codebuild/output/src1956426805/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src1956426805/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1956426805/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src1956426805/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src1956426805/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src1956426805/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1956426805/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexbGYJNEwl9Vl9XqE3aMOznzcWeUbVZiLjw0lT9C9oIlwMeta || {},
    component: () => import("/codebuild/output/src1956426805/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src1956426805/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmq9gM25FSyrNn7kF7IwbT2SNJgmd0swmXRFLiUwbjbQcMeta || {},
    component: () => import("/codebuild/output/src1956426805/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmuYpRStyUMuis4_5kCJDHEYRDVSdPkTvHdA81tJIPRWEMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src1956426805/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: complete1nOjJhHAO_45GABEa_45B_45oPt3hv42qF4wp1Kdomof5hK9QMeta || {},
    component: () => import("/codebuild/output/src1956426805/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerTRqugVQOjNp3vVUGoQoTtkL0Ymx1GU8_45X1h5cNWT9V8Meta || {},
    component: () => import("/codebuild/output/src1956426805/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src1956426805/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmQloY017mwHtbxIi0rulvigEInUi818Maf5KBhqP0B6IMeta || {},
    component: () => import("/codebuild/output/src1956426805/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src1956426805/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src1956426805/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeIUWVRuIiiUB3KQuvvjalRhooIxmHSLNbFHhh_3eMDPkMeta || {},
    component: () => import("/codebuild/output/src1956426805/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codebPw8nAgZE6gVcJDiyXj5EgrqMPZlQtj3a03bR2maUhUMeta || {},
    component: () => import("/codebuild/output/src1956426805/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: complete27hfb7tgKkwbVl4a0u5mk9aM3eZVBQ_459KTLAPugk5D8Meta || {},
    component: () => import("/codebuild/output/src1956426805/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerjzW6qIiufp2WyCIDCeuvOa4tyBj9h4IrWFNhjGOGQbAMeta || {},
    component: () => import("/codebuild/output/src1956426805/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src1956426805/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src1956426805/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmhrQEvdd_xDi25x3D6WtMGby_455VhF2KQdPo9WttXYD3IMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src1956426805/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completeUezLFjgvKWo2cf9UxgbaVmKcxN_45CCXwfL8uMdvcnRi4Meta || {},
    component: () => import("/codebuild/output/src1956426805/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexHfJpFQIFb8lTF_BgzR_45mmd8PbQAaPdXJiCb20iqCRhEMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src1956426805/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src1956426805/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completedii3t1C12rAXvfBL9ITjUTFI9WKUga_45AbHWhS4UWiv0Meta || {},
    component: () => import("/codebuild/output/src1956426805/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1956426805/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampleVfsZzA4f8QpU5LXJDPka33MHv5odFn56npUNWkuIhMgMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src1956426805/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45email8abyHtIjnAvuglf1iJv6sujs_FMuI3m29fB3NPHjLeEMeta || {},
    component: () => import("/codebuild/output/src1956426805/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmHyplM4oeZC13uTaOwjyKf9vy2vpC_vGmQp0IPV44f2kMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1956426805/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consenthlk3OsUJ7_lylObiGtBCLBKEnV3824Vs8Jz7cmoGdYUMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1956426805/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmhegujwnzKSC44S1hPbRmqv7zkV90T_qVxzShe12a_45SkMeta || {},
    component: () => import("/codebuild/output/src1956426805/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src1956426805/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeqvRiZKFUuB8asoaICQGVcAEPf8AWP4lG3Faggva6QfwMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src1956426805/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codekTtAR_pP6FYJuezqT8fXJzGLGXSyrNKyEImVYkM5of0Meta || {},
    component: () => import("/codebuild/output/src1956426805/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45password6H8ZfK8hclhaUm_45FSvssq0wUitTfQjo6F3TLQtd3iLsMeta || {},
    component: () => import("/codebuild/output/src1956426805/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src1956426805/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerK2BLUf_45wyT3r47pegfX74TgrrkSV4fwiQS2RBCMPQkwMeta || {},
    component: () => import("/codebuild/output/src1956426805/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeE5WUgxd5A7NoBMis0N4btUGDOuRlh7_gweYPrLLJQiMMeta || {},
    component: () => import("/codebuild/output/src1956426805/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src1956426805/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src1956426805/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src1956426805/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src1956426805/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src1956426805/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src1956426805/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src1956426805/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src1956426805/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src1956426805/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src1956426805/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src1956426805/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src1956426805/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src1956426805/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src1956426805/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src1956426805/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src1956426805/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src1956426805/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src1956426805/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src1956426805/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src1956426805/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]